import { SPONSOR_ACTIONS } from "./SPONSOR_ACTIONS"


export function sponsorReducer(state, action) {
  switch (action.type) {
    case SPONSOR_ACTIONS.SET_SPONSOR:
      return {
        ...state,
        sponsor: action.payload.sponsor,
      }
    case SPONSOR_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}